/**
 * 任务详情 assignmentDetailModule
 * 2019-05-13
 * Qian.qianchen
 */
'use strict';
angular.module("assignmentDetailModule", [])
    .controller("assignmentDetailCtrl", ["$scope", "$modalInstance", "$q", "$timeout", "assignmentId", "platform", "trsHttpService", "trsspliceString", "modalDialog", function($scope, $modalInstance, $q, $timeout, assignmentId, platform, trsHttpService, trsspliceString, modalDialog) {
        initStatus();
        initData();
        /**
         * [initStatus description] 状态初始化
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                params: {
                    serviceid: "mlf_taskcommand",
                    methodname: "getTaskDetail",
                    TaskId: assignmentId
                },
                platform: platform,
                showTab: 'detail'
            };
            $scope.data = {
                channels: ['文字', '图片', '视频', '直播', '可视化', 'H5', 'AR', '节目'],
                relevanceManuscriptItems: [],
            };
        }
        /**
         * [initData description] 数据初始化
         * @return {[type]} [description]
         */
        function initData() {
            requestData().then(function() {
                return initUserStatus();
            }).then(() => {
                if (angular.isDefined($scope.data.assignmentDetail.TASKADDRESS)) {
                    loadBMap().then(function() {
                        initMap();
                    });
                }
            });
        }
        /**
         * [requestData description] 数据请求
         * @return {[type]} [description]
         */
        function requestData() {
            let defer = $q.defer();
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.status.params, "POST").then(function(data) {
                $scope.data.assignmentDetail = data;
                console.log($scope.status.platform == 1 && ($scope.data.assignmentDetail.MYSTATUS == 2 || $scope.data.assignmentDetail.MYSTATUS == 3));
                defer.resolve(data);
            });
            return defer.promise;
        }
        /**
         * [loadBMap description] 地图加载
         * @return {[type]} [description]
         */
        function loadBMap() {
            var deffer = $q.defer();
            window.HOST_TYPE = "2";
            window.BMap_loadScriptTime = (new Date).getTime();
            LazyLoad.js(["https://api.map.baidu.com/getscript?v=2.0&ak=2OWwHzlWU6jNhRGfjIUZFx7UBZnqgGYl&services=&t=20190123111209"], function() {
                deffer.resolve();
            });
            return deffer.promise;
            /*var script = document.createElement("script");
            script.type = "text/javascript";
            script.src = "https://api.map.baidu.com/api?v=2.0&ak=2OWwHzlWU6jNhRGfjIUZFx7UBZnqgGYl";
            $("head").append(script);*/
        };
        /**
         * [initMap description] 初始化地图
         * @return {[type]} [description]
         */
        function initMap() {
            $scope.mapContainer = new BMap.Map("map-container");
            $scope.mapContainer.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
            $scope.mapContainer.addControl(new BMap.MapTypeControl()); //添加地图类型控件
            var point = new BMap.Point($scope.data.assignmentDetail.TASKADDRESS.value.lng, $scope.data.assignmentDetail.TASKADDRESS.value.lat);
            var marker = new BMap.Marker(point);
            $scope.mapContainer.addOverlay(marker);
            $scope.mapContainer.centerAndZoom(point, 19);
            var autoComp = new BMap.Autocomplete({
                "location": $scope.mapContainer
            });
            autoComp.setInputValue($scope.data.assignmentDetail.TASKADDRESS.name);
            //搜索结果绑定hover事件
            autoComp.addEventListener("onhighlight", function(e) {
                var str = "",
                    _value, value;
                if (e.fromitem.index > -1) {
                    _value = e.fromitem.value;
                    value = _value.province + _value.city + _value.district + _value.street + _value.business;
                }
                str = "FromItem<br />index = " + e.fromitem.index + "<br />value = " + value;
                if (e.toitem.index > -1) {
                    _value = e.toitem.value;
                    value = _value.province + _value.city + _value.district + _value.street + _value.business;
                }
                str += "<br />ToItem<br />index = " + e.toitem.index + "<br />value = " + value;
                // $("#searchResultPanel").html(str);
            });
            //搜索结果绑定点击事件
            autoComp.addEventListener("onconfirm", function(e) {
                var _value = e.item.value;
                var myValue = _value.province + _value.city + _value.district + _value.street + _value.business;
                var str = "onconfirm<br />index = " + e.item.index + "<br />myValue = " + myValue;
                // $("#searchResultPanel").html(str);
                assignmentAddress.name = myValue;
                $scope.hiddenSuggestion();
                // setPlace(myValue);
            });
        }
        /**
         * [initUserStatus description] 执行人状态初始化
         * @return {[type]} [description]
         */
        function initUserStatus() {
            let defer = $q.defer();
            let params = {
                serviceid: "mlf_taskcommand",
                methodname: "getUserStatus",
                TaskId: assignmentId,
                UserIds: $scope.data.assignmentDetail.USERIDS
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "POST").then(function(result) {
                $scope.data.userStatus = [];
                Object.keys(result).forEach(function(key) {
                    $scope.data.userStatus.push({
                        name: key,
                        status: result[key]
                    });
                });
                defer.resolve();
            });
            return defer.promise;
        }
        /**
         * [cancel description] 取消/关闭
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        }
        /**
         * [tabSelect description] tab切换
         * @param  {[type]} tab [description]
         * @return {[type]}     [description]
         */
        $scope.tabSelect = function(tab) {
            if ($scope.status.showTab == tab) {
                return;
            } else {
                $scope.status.showTab = tab;
            }
            if ($scope.status.showTab == 'detail') {
                loadBMap().then(function() {
                    initMap();
                });
            }
            if ($scope.status.showTab == 'manuscript') {
                queryTaskRelevancsManuscriptData();
            }
        };
        /**
         * [reportInit description] 选题初始化
         * @param  {[type]} report [description]
         * @return {[type]}        [description]
         */
        $scope.reportInit = function(report) {
            if (report.REPORTTYPE == 1) {
                report.type = '普通';
            } else if (report.REPORTTYPE == 2) {
                report.type = '重要';
            } else if (report.REPORTTYPE == 3) {
                report.type = '紧急';
            } else if (report.REPORTTYPE == 4) {
                report.type = '敏感';
            }
            report.assignmentTime = report.STARTTIME + ' - ' + report.ENDTIME;
            report.executor = trsspliceString.spliceString(report.EXECUTOR, 'USERNAME', '、');
            var metaObj = report.METATYPEINFO[0];
            report.metatypeApp = metaObj.METATYPEBYAPP ? metaObj.METATYPEBYAPP.split(',').map(function(idx) {
                return $scope.data.channels[parseInt(idx) - 1];
            }).concat(metaObj.METATYPEBYAPPOTHER ? [metaObj.METATYPEBYAPPOTHER] : []).join('、') : (metaObj.METATYPEBYAPPOTHER ? [metaObj.METATYPEBYAPPOTHER] : []).join('、');
            report.metatypeWeb = metaObj.METATYPEBYWEB ? metaObj.METATYPEBYWEB.split(',').map(function(idx) {
                return $scope.data.channels[parseInt(idx) - 1];
            }).concat(metaObj.METATYPEBYWEBOTHER ? [metaObj.METATYPEBYWEBOTHER] : []).join('、') : (metaObj.METATYPEBYWEBOTHER ? [metaObj.METATYPEBYWEBOTHER] : []).join('、');
            report.metatypePaper = metaObj.METATYPEBYPAPER ? metaObj.METATYPEBYPAPER.split(',').map(function(idx) {
                return $scope.data.channels[parseInt(idx) - 1];
            }).concat(metaObj.METATYPEBYPAPEROTHER ? [metaObj.METATYPEBYPAPEROTHER] : []).join('、') : (metaObj.METATYPEBYPAPEROTHER ? [metaObj.METATYPEBYPAPEROTHER] : []).join('、');
            report.metatypeWeibo = metaObj.METATYPEBYWEIBO ? metaObj.METATYPEBYWEIBO.split(',').map(function(idx) {
                return $scope.data.channels[parseInt(idx) - 1];
            }).concat(metaObj.METATYPEBYWEIBOOTHER ? [metaObj.METATYPEBYWEIBOOTHER] : []).join('、') : (metaObj.METATYPEBYWEIBOOTHER ? [metaObj.METATYPEBYWEIBOOTHER] : []).join('、');
            report.metatypeWeichat = metaObj.METATYPEBYWECHAT ? metaObj.METATYPEBYWECHAT.split(',').map(function(idx) {
                return $scope.data.channels[parseInt(idx) - 1];
            }).concat(metaObj.METATYPEBYWECHATOTHER ? [metaObj.METATYPEBYWECHATOTHER] : []).join('、') : (metaObj.METATYPEBYWECHATOTHER ? [metaObj.METATYPEBYWECHATOTHER] : []).join('、');
            report.metatypeTv = metaObj.METATYPEBYTV ? metaObj.METATYPEBYTV.split(',').map(function(idx) {
                return $scope.data.channels[parseInt(idx) - 1];
            }).concat(metaObj.METATYPEBYTVOTHER ? [metaObj.METATYPEBYTVOTHER] : []).join('、') : (metaObj.METATYPEBYTVOTHER ? [metaObj.METATYPEBYTVOTHER] : []).join('、');
            report.metatypeBroadcast = metaObj.METATYPEBYBROADCAST ? metaObj.METATYPEBYBROADCAST.split(',').map(function(idx) {
                return $scope.data.channels[parseInt(idx) - 1];
            }).concat(metaObj.METATYPEBYBROADCASTOTHER ? [metaObj.METATYPEBYBROADCASTOTHER] : []).join('、') : (metaObj.METATYPEBYBROADCASTOTHER ? [metaObj.METATYPEBYBROADCASTOTHER] : []).join('、');
            report.metatypeOther = metaObj.METATYPEBYOTHER;
        }
        /**
         * [acceptAssignment description] 接受任务
         * @param  {[type]} assignment [description] 任务
         * @return {[type]}            [description]
         */
        $scope.accept = function() {
            var defer = $q.defer();
            var params = {
                serviceid: "mlf_taskcommand",
                methodname: "acceptTask",
                TaskIds: assignmentId
            };
            modalDialog.confirmModal('接受任务', '是否确认接受该任务？', function() {
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "POST").then(function(data) {
                    modalDialog.alertType('接受成功', '', 'success', false, function() {
                        $modalInstance.close('success');
                        defer.resolve();
                    }, 1500);
                }, function() {
                    $modalInstance.close('fail');
                    defer.reject();
                });
            });
            return defer.promise;
        }
        /**
         * [finishAssignment description] 任务完成
         * @param  {[type]} assignment [description] 任务
         * @return {[type]}            [description]
         */
        $scope.finish = function() {
            var defer = $q.defer();
            var params = {
                serviceid: "mlf_taskcommand",
                methodname: "completeTask",
                TaskIds: assignmentId
            };
            modalDialog.confirmModal('完成任务', '是否确认完成该任务？', function() {
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "POST").then(function(data) {
                    modalDialog.alertType('接受成功', '', 'success', false, function() {
                        $modalInstance.close('success');
                        defer.resolve();
                    }, 1500);
                }, function() {
                    $modalInstance.close('fail');
                    defer.reject();
                });
            });
            return defer.promise;
        }

        /**
         * [queryTaskRelevancsManuscriptData 获取关联稿件数据]
         * @return {[type]} [description]
         */
        function queryTaskRelevancsManuscriptData() {
            queryTaskRelevanceManuscript().then(function(data) {
                // for (var i = 0; i < data.length; i++) {
                    queryChannelManuscript(data[0]).then(function(){
                        data[0].OPEN = true;
                    });
                // }
            });
        }

        /**
         * [queryTaskRelevanceManuscript 查询任务关联稿件]
         * @return {[type]} [description]
         */
        function queryTaskRelevanceManuscript() {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_taskcommand',
                methodname: 'queryTaskCommandDocs',
                TaskId: assignmentId,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.data.relevanceManuscriptItems = data;
                defer.resolve($scope.data.relevanceManuscriptItems);
            });
            return defer.promise;
        }

        /**
         * [queryChannelManuscript 查询关联稿件下的渠道稿件]
         * @param  {[type]} item [description]
         * @return {[type]}    [description]
         */
        function queryChannelManuscript(item) {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_taskcommand',
                methodname: "queryDocRels",
                MetadataId: item.METADATAID
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                item.ListItems = data;
                // item.OPEN = data.length > 0 ? true : false;
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [cancelRelevanceManuscript 取消关联稿件]
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.cancelRelevanceManuscript = function(item) {
            var params = {
                serviceid: 'mlf_taskcommand',
                methodname: 'delTaskCommandDocRels',
                TaskId: assignmentId,
                DocIds: item.METADATAID,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                modalDialog.alertType(data.DETAIL, '', data.ISSUCCESS == 'true' ? 'success' : 'error', false, function() {
                    queryTaskRelevancsManuscriptData();
                });
            });
        };

        /**
         * [toggleAccordion 手风琴开关]
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.toggleAccordion = function(item) {
            item.OPEN = !item.OPEN;
            if (!item.ListItems) {
                queryChannelManuscript(item);
            }
        };
    }]);